import React from "react";
import i18n from "../../../i18n";
import swal from "sweetalert";
import { updateOfficerRank, deleteOfficerRank } from "../../../models/officers";

export class OfficerRankRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: {},
      update: {},
      ranks: [],
      errors: {},
      signature: null,
      is_edit: false,
    };
    this.handleUpdateChange = this.handleUpdateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
  }

  componentDidMount() {}

  handleUpdateChange(event) {
    let { update } = this.state;
    update[event.target.name] = event.target.value;
    this.setState({ update });
  }

  async handleSubmit(event) {
    try {
      const { update } = this.state;
      const formData = new FormData();
      formData.append("id", update.id);
      formData.append("rank_en", update.rank_en);
      formData.append("rank_ar", update.rank_ar);
      const response = await updateOfficerRank(formData);
      if (response.success) {
        swal(i18n.t("success"), "Rank successfully created!!", "success", {
          buttons: false,
          timer: 2000,
        });
        this.props.triggerReloadRanks();
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += "\n" + element;
          }
        }
        swal("Failed", error_message, "error");
      }
    } catch (err) {
      console.log(err);
    }
  }

  async deleteRow(id) {
    var ans = window.confirm("Do you want to continue.?");
    if (ans) {
      const response = await deleteOfficerRank({ id: id });
      if (response.success) {
        swal(i18n.t("success"), "Rank deleted", "success", {
          buttons: false,
          timer: 2000,
        })
          .then((response) => {
            this.props.triggerReloadRanks();
          })
          .catch((response) => {
            swal("Failed", "Something went wrong", "error");
          });
      }
    }
  }

  render() {
    let { item } = this.props;
    let { is_edit } = this.state;
    return (
      <React.Fragment>
        <tr key={item.id}>
          <td>
            {!is_edit ? item.rank_en : ""}
            {is_edit && (
              <input
                type="text"
                name="rank_en"
                value={this.state.update.rank_en}
                onChange={this.handleUpdateChange}
                autoComplete="rank_en"
                className="form-control custom-input "
              />
            )}
          </td>
          <td>
            {!is_edit ? item.rank_ar : ""}
            {is_edit && (
              <input
                type="text"
                name="rank_ar"
                value={this.state.update.rank_ar}
                onChange={this.handleUpdateChange}
                autoComplete="rank_ar"
                className="form-control custom-input "
              />
            )}
          </td>
          <td>
            <div className="d-flex justify-content-center align-items-center">
              {!is_edit && (
                <button
                  className="btn btn-warning btn-sm text-white m-1 rounded-1"
                  onClick={(e) => {
                    this.setState({
                      is_edit: !this.state.is_edit,
                      update: item,
                    });
                  }}
                >
                  <i className="fa fa-pencil"></i>&nbsp;
                  {i18n.t("edit")}
                </button>
              )}
              {is_edit && (
                <button
                  className="btn btn-primary btn-sm text-white m-1 rounded-1"
                  onClick={(e) => {
                    this.handleSubmit();
                  }}
                >
                  <i className="fa fa-save"></i>&nbsp;
                  {i18n.t("save")}
                </button>
              )}
              <button
                className="btn btn-danger btn-sm text-white m-1 rounded-1"
                onClick={(e) => {
                  this.deleteRow(item.id);
                }}
              >
                <i className="fa fa-times"></i>&nbsp;
                {i18n.t("delete")}
              </button>
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  }
}
